// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--bdbac";
export var footer = "Footer-module--footer--4b235";